export default "__VITE_ASSET__2b42d8c6__"